export default __webpack_public_path__ + "static/media/bookmark.ab240af1.svg";